import { createSlice } from '@reduxjs/toolkit';
import { EditorType } from '@wix/ambassador-metasite-search-v2-search-entry/types';

import { loadHomepageContent } from '../thunks/homepage.thunk';
import { IHomepageSectionState, IHomepageState } from './types';

const createEmptySectionState = <T>(): IHomepageSectionState<T> => ({
  data: null,
  loading: false,
  error: null,
});

const initialState: IHomepageState = {
  content: createEmptySectionState(),
  articles: createEmptySectionState(),
  reportABugFlowStarted: false,
  showReportABugConfirmationModal: false,
  reportABugPosition: 0,
  searchConfig: {},
};

export const homepageSlice = createSlice({
  name: 'homepage',
  initialState,
  reducers: {
    reportABugFlowStarted: (state, action) => {
      state.reportABugFlowStarted = action.payload;
    },
    setShowReportABugConfirmationModal: (state, action) => {
      state.showReportABugConfirmationModal = action.payload;
    },
    setReportABugPosition: (state, action) => {
      state.reportABugPosition = action.payload;
    },
    setReportABugText: (state, action) => {
      state.reportABugText = action.payload;
    },
    setEditorType: (state, action) => {
      state.searchConfig = {
        ...state.searchConfig,
        filters: {
          ...state.searchConfig.filters,
          editorType: action.payload,
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadHomepageContent.pending, (state) => {
      state.content.error = null;
      state.content.loading = true;
    });

    builder.addCase(loadHomepageContent.fulfilled, (state, action) => {
      state.content.error = null;
      state.content.loading = false;
      state.content.data = action.payload;
      const searchConfig = action.payload.header?.searchConfig;
      if (searchConfig) {
        state.searchConfig = {
          ...searchConfig,
          filters: {
            ...searchConfig.filters,
            editorType: searchConfig.filters?.editorType as EditorType,
          },
        };
      }
    });

    builder.addCase(loadHomepageContent.rejected, (state, action) => {
      state.content.error = action.error as string;
      state.content.loading = false;
    });
  },
});
